module.exports = __webpack_public_path__ + "img/img_helper_teleconsulta.23b02c48.svg";